/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_Too_ShortInputs */

const en_us2_coach_mic_too_short = /** @type {(inputs: Coach_Mic_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hold to record audio`)
};

const pt_br2_coach_mic_too_short = /** @type {(inputs: Coach_Mic_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segure para gravar o áudio`)
};

const es_419_coach_mic_too_short = /** @type {(inputs: Coach_Mic_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantén presionado para grabar`)
};

const pt_pt2_coach_mic_too_short = /** @type {(inputs: Coach_Mic_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantém premido para gravar o áudio`)
};

const fr_fr2_coach_mic_too_short = /** @type {(inputs: Coach_Mic_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintiens pour enregistrer`)
};

const de_de2_coach_mic_too_short = /** @type {(inputs: Coach_Mic_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halten, um aufzunehmen`)
};

const it_it2_coach_mic_too_short = /** @type {(inputs: Coach_Mic_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tieni premuto per registrare`)
};

/**
* | output |
* | --- |
* | "Hold to record audio" |
*
* @param {Coach_Mic_Too_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_too_short = /** @type {((inputs?: Coach_Mic_Too_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_Too_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_too_short(inputs)
	if (locale === "es-419") return es_419_coach_mic_too_short(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_too_short(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_too_short(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_too_short(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_too_short(inputs)
	return en_us2_coach_mic_too_short(inputs)
});
export { coach_mic_too_short as "coach-mic.too_short" }